import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setOrgTemplate } from "./api";
import type {
  BranchTemplateSettingsResponse,
  SetBranchTemplateRequest,
} from "./api";

// PUT org-дефолта. На успех инвалидируем org-запрос — секция
// перерисуется с новым override без ручного refetch'а.
export function useSetOrgTemplate(): ReturnType<
  typeof useMutation<
    BranchTemplateSettingsResponse,
    Error,
    SetBranchTemplateRequest
  >
> {
  const queryClient = useQueryClient();
  return useMutation<
    BranchTemplateSettingsResponse,
    Error,
    SetBranchTemplateRequest
  >({
    mutationFn: (body) => setOrgTemplate(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ["branchNameTemplate", "org"],
      });
    },
  });
}
